import I18n from 'lib/i18n'
import React from 'react'
import { useValues } from 'kea'

import filtersLogic from '~/scenes/search/filters-page/logic'

const Actions = ({ onApply, onClear }) => {
  const { hasChangesToClear } = useValues(filtersLogic)

  return (
    <div className='submenu-actions' style={{ justifyContent: hasChangesToClear ? 'space-between' : 'flex-end' }}>
      {hasChangesToClear && (
        <button onClick={onClear} className='submenu-action clear'>
          {I18n.t('react.search.filters.clear_button')}
        </button>
      )}
      <button onClick={onApply} className='submenu-action apply'>
        {I18n.t('layouts.header.menu.country_menu.save')}
      </button>
    </div>
  )
}

export default Actions
